import { flattenEntry, getEntries } from '@/lib/cms';

import { Text } from '@/components/atoms/text';
import { LimitPagination } from '@/components/cms/types/entry';
import ArticleItem, {
  ArticleItemProps,
} from '@/components/organisms/relatedArticles/RelatedArticleItem';

import { NewestArticle } from './NewestArticle';
import { getText } from '@/lib/i18n/i18n.server';

export interface BlogOverviewProps {
  items: ArticleItemProps[];
  initialTopicSlug?: string;
}

export const ARTICLES_PER_PAGE = 1;

export const BlogOverview = async ({
  items,
  initialTopicSlug,
}: BlogOverviewProps) => {
  const initialArticle = await getArticles(initialTopicSlug);
  const texts = await getText();

  return (
    <div className='bg-neutral-N00 md:border-neutral-N10 md:dark:bg-neutral-dark-N94 w-full md:flex md:rounded-3xl md:border md:p-6 md:shadow-md'>
      <div className='w-full min-w-[330px] pb-8 md:pr-6'>
        <Text variant='subtitle-l' classNames={{ wrapper: 'text-left pb-6' }}>
          {texts.blog_overview.most_recent}
        </Text>
        <NewestArticle initialArticle={initialArticle} />
      </div>
      <div className='md:border-neutral-N20 md:dark:border-neutral-dark-N80 scrollbar dark:scrollbar-dark md:max-h-[566px] md:w-full md:max-w-[430px] md:overflow-y-scroll md:border-l md:pl-6 md:pr-[14px]'>
        <Text variant='subtitle-l' classNames={{ wrapper: 'pb-6 text-left' }}>
          {texts.blog_overview.most_popular}
        </Text>
        {items.map((item, key) => (
          <div className='overflow-x-hidden pb-6' key={key}>
            <ArticleItem key={item.slug} {...item} size='small' />
          </div>
        ))}
      </div>
    </div>
  );
};

export async function getArticles(topicSlug?: string) {
  const entries = await getEntries({
    contentType: '/blogs',
    query: {
      pLevel: 'deep',
      sort: 'metadata.releaseDate:desc',
      filters: {
        metadata: {
          ...(!!topicSlug && { topics: { slug: { $containsi: topicSlug } } }),
        },
      },
      pagination: {
        start: 0,
        limit: ARTICLES_PER_PAGE,
      },
    },
  });

  if (!entries?.data) return;
  return {
    data: entries.data.map(flattenEntry),
    pagination: (entries.meta?.pagination ?? {}) as LimitPagination,
  };
}
